import { makeStyles } from '@material-ui/core';

export const useDeadlineExpiredWithNoReverseStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
    marginTop: 16,
    color: '#464646',
    textAlign: (props) => (props.mobile ? 'center' : null),
  },
  image: {
    width: 165,
    marginBottom: 20,
  },
  imageContainer: {
    textAlign: 'center',
  },
  button: {
    width: 200,
    margin: '0 auto',
    marginBottom: (props) => (props.mobile ? 25 : 0),
  },
  titleMessageNotReverse: {
    color: '#464646',
    fontSize: '16px',
    marginBottom: 15,
    marginTop: -30,
    textAlign: 'center',
  },
  titleMessageNotDoneReverse: {
    color: '#464646',
    fontSize: '16px',
    marginBottom: 15,
    marginTop: 15,
    textAlign: 'center',
  },
  titlePayMethodUsed: {
    color: '#464646',
    fontSize: '16px',
    marginBottom: -15,
    marginTop: 15,
    textAlign: (props) => (props.mobile ? 'center' : ''),
  },
  titleBankUsed: {
    color: '#464646',
    fontSize: '16px',
    marginBottom: -15,
    marginTop: 15,
    textAlign: (props) => (props.mobile ? 'center' : ''),
  },
  titleComment: {
    color: '#464646',
    fontSize: '16px',
    marginBottom: -15,
    marginTop: 15,
    textAlign: (props) => (props.mobile ? 'center' : ''),
  },
  messageInfoMethodRipleyOrCheck: {
    color: '#464646',
    fontSize: '20px',
    marginBottom: 15,
    marginTop: 15,
    textAlign: 'center',
  },
}));
